<template>
	<div class="pane">
		<spread-table v-show="!loadError" :spreadCommodity="spreadCommodity" :list="moreSpreadList"/>
    <div v-show="!empty && !loadError" class="hint-pane">到底啦</div>
    <van-empty v-show="empty && !loadError && !loading" description="暂无数据"></van-empty>
    <error-hint v-show="loadError" @click="listMoreHistorySpread"/>
    <loading-pane v-show="loading"/>
	</div>
</template>
<script>
import api from '@/api'
import SpreadTable from '../components/spreadData/SpreadTable.vue'
import ErrorHint from '../components/ErrorHint.vue'
import LoadingPane from '../components/LoadingPane.vue'
import { Empty } from 'vant'
export default {
	name: 'MoreHistorySpread',
  components: { 
    SpreadTable, 
    ErrorHint,
    LoadingPane,
    [Empty.name]: Empty
  },
	props: {
		spreadCommodity: {
			type: Object
		}
	},
	beforeRouteEnter(to, from , next){
		next(vm => {
      vm.listMoreHistorySpread()
      document.documentElement.scrollTop = 0
    })
	},
	data(){
		return {
			moreSpreadList: [],
      loading: true,
      loadError: false,
		}
	},
  methods: {
    async listMoreHistorySpread(){
      let res;
      this.loading = true;
      try{
        res = await api.listMoreHistorySpread(this.spreadCommodity.spread_config_id);
        console.log('更多历史价差', res);
        this.moreSpreadList = res;
        this.loadError = false;
      }catch(err){
        this.loadError = true;
        console.error('更多历史价差加载失败', err);
      }
      this.loading = false;
    }
  },
  computed: {
    empty(){
      return this.moreSpreadList.length === 0
    }
  }
}
</script>
<style scoped>
.pane{
  min-height: 100vh;
}
</style>